"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var getters_1 = require("./getters");
var mutations_1 = require("./mutations");
var state_1 = require("./state");
__export(require("./checkin_time"));
__export(require("./direction_config"));
__export(require("./find_station"));
__export(require("./find_transportations_params"));
__export(require("./pax_discount"));
__export(require("./selection_list"));
__export(require("./transport_config"));
__export(require("./transportation"));
var TransportRail = /** @class */ (function () {
    // create everything
    function TransportRail(plugins) {
        // resolve namespacing, applies "foo/bar/..." stuff automatically
        this.namespaced = true;
        this.mutations = mutations_1.default;
        this.getters = getters_1.default;
        this.actions = actions_1.default;
        this.plugins = [];
        this.state = new state_1.State();
        this.plugins = plugins;
    }
    return TransportRail;
}());
exports.TransportRail = TransportRail;
//# sourceMappingURL=index.js.map